export default {
  "custom": {
    linkedReference: 'Связанная ссылка',
    boot: 'Включить',
    shutDown: 'Выключить',
    notLinked: 'Не связано',
    maxLinkedTip: 'Разрешено не более 2 {type}-связей, автоматически восстановлено до Не связано',

    bar_Power: 'Питание',
    bar_Video: 'Переключение видео',
    bar_Vol: 'Громкость',
    bar_Audio: 'Переключение аудио',
    bar_Serial: 'Последовательный',
    bar_Air: 'Кондиционер',
    bar_Projection: 'Экран проектора',
    bar_Remote: 'Дистанционное управление',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: 'Вы должны выбрать все три изображения одновременно',
    notSelected: 'Не выбрано',
    choose: 'Выбрать',
    disable: 'Отключить',
    "longPressAndDrag": "Длительно нажмите и перетащите, чтобы изменить порядок списка",
    "isrestoreDefault": "Вы хотите восстановить состояние по умолчанию?",
    "saveAndSync": "Сохранить и синхронизировать",
    "restoreDefault": "Восстановить по умолчанию",
    "limitPNG": "Можно загружать только изображения PNG!",
    "limit1M": "Размер изображения не может превышать 1 МБ!",
    "selectTheImage": "Выбрать изображение",
    "textsuggestions": "Рекомендуется: белый значок PNG 48*48 px, меньше 1 МБ",
    "iconLibrary": "Библиотека иконок",
    "panelNavigationBarCustomization": "Панель навигации",
    "logoCustomization": "Логотип панели"
  },
  outlook: {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: 'Не удалось привязать: этот арендатор Microsoft (ID: ',
    AuthVerify4004Two: ') уже занят организацией [',
    AuthVerify4004Three: ']. Чтобы повторно привязать, сначала отвяжите его от исходной организации или используйте другого арендатора Microsoft.',
    theMicrosoftTenantIsOccupied: 'Арендатор Microsoft уже занят',
    Viewtutorial: "Просмотреть руководство по привязке",
    checktenantID: "Пожалуйста, проверьте, правильны ли ваш идентификатор арендатора, идентификатор приложения и ключ приложения.",
    ErrorCode: "Код ошибки:",
    AuthorizationFailed: "Ошибка авторизации",
    Accesshasbeengranted: "Доступ к Microsoft Graph API предоставлен",
    successfullyauthorizedDescribe: "Необходимые разрешения успешно предоставлены. Данные переговорной комнаты будут синхронизированы автоматически. Пожалуйста, закройте эту страницу.",
    Close: "Закрыть",
    resourceID: "Идентификатор ресурса",
    dialogTips: "Подсказки",
    theAuthorizationIsDeleted: "Авторизация удалена",
    theBindingIsSuccessful: "Привязка успешна",
    theUnbindingIsSuccessful: "Отвязка успешна",
    unbindingFailed: "Ошибка отвязки",
    theUnbindingHasBeenUnbound: "Отвязка отменена",
    continueUnbinding: "Синхронизация Outlook будет остановлена, а все предстоящие события удалены. Продолжить отвязку?",
    areYouSureAboutUnbinding: "Все предстоящие события Outlook будут удалены, а синхронизация остановлена. Это действие нельзя отменить. Подтвердить отвязку?",
    UnbindNotSynchronized: "После привязки новые события Outlook для этой комнаты будут синхронизироваться автоматически (прошлые события синхронизироваться не будут)",
    unbinding: "Отвязать",
    bindUnableToSelect: "Уже привязан, выбор невозможен",
    permissAThird: "Пожалуйста, авторизуйте привязку сторонних ресурсов",
    resourceMailbox: "Почтовый ящик ресурса:",
    PleasecheckID: "Ошибка авторизации! Пожалуйста, проверьте правильность вашего идентификатора арендатора, идентификатора приложения и секрета клиента.",
    Waitingforauthorization: "Ожидание авторизации...",
    Pleasecompletetheauthorization: "Открыта страница входа Microsoft 365. Пожалуйста, войдите с учетной записью администратора для завершения авторизации.",
    pleaseEnterTheTenantID: "Введите идентификатор арендатора",
    pleaseEnterTheClientID: "Введите идентификатор приложения",
    pleaseEnterTheClientSecret: "Введите секрет клиента",
    Authorizationcompleted: "Авторизация завершена",
    Authorizelogin: "Авторизовать вход в Microsoft 365",
    ApplicationID: "Идентификатор арендатора",
    ClientID: "Идентификатор приложения",
    ClientSecret: "Секрет клиента",
    registTipOne: "Пожалуйста, следуйте",
    registTipTwo: "Руководству по привязке",
    registTipThree: "Завершите регистрацию приложения Azure и настройки разрешений перед заполнением полей ниже.",
    MicrosoftDescribe: "Привязка Microsoft 365 позволяет автоматически синхронизировать собрания, забронированные в Outlook/Teams, с консолью Q-NEX и планировщиком переговорных комнат.",
    Addcalendarservice: "Настройки синхронизации календаря",
    Lasttimesynchronization: "Время последней синхронизации",
    Allocated: "Назначено",
    Total: "Всего",
    Conferenceroomresources: "Ресурсы переговорных комнат",
    Bindingtime: "Время привязки",
    Bindtheplatform: "Платформа привязки",
    Synchronousstate: "Статус синхронизации",
    Organizationname: "Название организации",
    Bindthirdpartycalendar: "Привязать сторонний календарь",
    TenantIDTip: "Уникальный идентификатор в Azure AD",
    ApplicationIDTip: "Идентификатор приложения, зарегистрированный в Azure",
    ApplicationSecretTip: "Секрет клиента, созданный в Azure для аутентификации"
  },
  "meetingManager": {
    IdleDisplayTextTable: 'Текст отображения в режиме ожидания',
    IdleDisplayText: 'Текст отображения в режиме ожидания:',
    IdleDisplayTextContent: 'Текст, отображаемый, когда комната пуста (по умолчанию: «Свободно»)',

    duplicateMeetingRoomName: 'Дублирующееся название переговорной',
    duplicateMeetingRoomNameContent: 'Переговорная с названием «{duplicate_content}» уже существует. Пожалуйста, введите другое название.',
    NumberOfRoomPanels: 'Количество панелей зала',
    "Thecurrentterminalhasbeenboundtoanotherorganization": "Текущий терминал уже привязан к другой организации.",
    "theTerminalNameOrIDIsDuplicated": "Имя или ID панели одинаковые",
    theRoomNameOrIDIsDuplicated: 'Название переговорной комнаты или местоположение уже существует.',
    "AddMeetingRoom": "Добавить комнату для встреч",
    "EditMeetingRoom": "Редактировать комнату для встреч",
    "MeetingRoomName": "Название комнаты для встреч:",
    "Location": "Местоположение:",
    "ReservationApproval": "Одобрение бронирования:",
    "ApprovalListYes": "да",
    "ApprovalListNo": "нет",
    "Capacity": "Вместимость:",
    "RoomStatus": "Статус комнаты:",
    "BindRoomDisplay": "Привязать панель комнаты:",
    "meeting_btnAdd": "Добавить",
    "meeting_btnEdit": "Редактировать",
    "meeting_btnBind": "Привязать устройство",
    "meeting_btnDel": "Удалить",
    "meeting_tableRoomName": "Название комнаты для встреч",
    "meeting_tableRoomPlace": "Местоположение",
    "meeting_tableAppointmentApproval": "Одобрение бронирования",
    "meeting_tableCapacityForPeople": "Вместимость",
    "meeting_tableMeetingRoomStatus": "Статус комнаты",
    "meeting_tableAvaliable": "Доступна",
    "meeting_tableOutofService": "Не в сети",
    "meeting_tableDoorBind": "Привязать дверь",
    "meeting_tableBindNPS": "Привязать NPS",
    "meeting_tableActions": "Действия",
    "door_theNameOfTheTerminal": "Имя панели:",
    "door_deviceID": "ID панели:",
    "door_Wallpaper": "Обои:",
    "door_Wallpaper_text": "Рекомендуемый размер изображения: 1280x800, в формате PNG",
    "door_bindAMeetingRoom": "Привязать комнату для встреч:",
    "door_table_name": "Имя панели",
    "door_table_deviceID": "ID панели",
    "door_table_status": "Статус",
    "door_table_ipAddress": "IP-адрес",
    "door_table_bindAMeetingRoom": "Привязать комнату для встреч",
    "door_btnAdd": "Добавить",
    "door_btnBatchAdd": "Добавить пакетно",
    "door_btnEdit": "Редактировать",
    "door_btnBatchEdit": "Редактировать пакетно"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "Добавить конфигурацию",
    "configurationEditTitle": "Редактировать конфигурацию",
    "dialogConfigName": "Название конфигурации",
    "selectNMPAndNDP": "Целевые устройства",
    "powerControl": "Управление питанием",
    "executeCommand": "Сделать",
    "tableConfigName": "Название конфигурации",
    "selectConfig": "Пожалуйста, выберите конфигурацию"
  },
  "NPS": {
    "Relay": "Реле",
    "RelaySettings": "Настройки реле",
    "DevicePower": "Управление питанием устройства",
    "DeviceElevation": "Управление подъемом",
    "LinageWithNPSPower": "Связь с питанием NPS",
    "PresentationSwitch": "Переключатель презентации",
    "Duplicate": "Дублировать",
    "LinkagewithNPSPowe": "Связь с питанием NPS"
  },
  "PTZ": {
    "powerSupplyON": "Включить",
    "powerSupplyOFF": "Выключить",
    "LEFT": "Влево",
    "RIGHT": "Вправо",
    "UP": "Вверх",
    "DOWN": "Вниз",
    "HOME": "Домой",
    "ENLARGE": "Увеличить",
    "REDUCTION": "Уменьшить",
    "StopMovement": "Остановить движение",
    "STOP": "Остановить зум",
    "FOCUS": "Фокусировка",
    "SET_PRESETS0": "НАСТРОИТЬ_ПРЕСЕТ0",
    "SET_PRESETS1": "НАСТРОИТЬ_ПРЕСЕТ1",
    "SET_PRESETS2": "НАСТРОИТЬ_ПРЕСЕТ2",
    "SET_PRESETS3": "НАСТРОИТЬ_ПРЕСЕТ3",
    "SET_PRESETS4": "НАСТРОИТЬ_ПРЕСЕТ4",
    "SET_PRESETS5": "НАСТРОИТЬ_ПРЕСЕТ5",
    "SET_PRESETS6": "НАСТРОИТЬ_ПРЕСЕТ6",
    "SET_PRESETS7": "НАСТРОИТЬ_ПРЕСЕТ7",
    "SET_PRESETS8": "НАСТРОИТЬ_ПРЕСЕТ8",
    "SET_PRESETS9": "НАСТРОИТЬ_ПРЕСЕТ9",
    "USE_PRESETS0": "ИСПОЛЬЗОВАТЬ_ПРЕСЕТ0",
    "USE_PRESETS1": "ИСПОЛЬЗОВАТЬ_ПРЕСЕТ1",
    "USE_PRESETS2": "ИСПОЛЬЗОВАТЬ_ПРЕСЕТ2",
    "USE_PRESETS3": "ИСПОЛЬЗОВАТЬ_ПРЕСЕТ3",
    "USE_PRESETS4": "ИСПОЛЬЗОВАТЬ_ПРЕСЕТ4",
    "USE_PRESETS5": "ИСПОЛЬЗОВАТЬ_ПРЕСЕТ5",
    "USE_PRESETS6": "ИСПОЛЬЗОВАТЬ_ПРЕСЕТ6",
    "USE_PRESETS7": "ИСПОЛЬЗОВАТЬ_ПРЕСЕТ7",
    "USE_PRESETS8": "ИСПОЛЬЗОВАТЬ_ПРЕСЕТ8",
    "USE_PRESETS9": "ИСПОЛЬЗОВАТЬ_ПРЕСЕТ9"
  },
  "schedule": {
    "startLinkPowerStart": "Включить (Реле CBXs)  ",
    "startLinkPowerStop": "Выключить (Реле CBXs)  ",
    "dehumidification": "Сухо  ",
    "airSupply": "Вентилятор  ",
    "masterControl": "Основное:  ",
    "powerSupply": "Питание  ",
    "lockScreen": "Блокировка  ",
    "RecordingControl": "Контроль записи  ",
    "RecordingControlSystem": "Система захвата лекций  ",
    "LiquidCrystal": "Интерактивная панель с плоским экраном  ",
    "projector": "Проектор  ",
    "othertype": "Другое  ",
    "childLock": "Блокировка для детей  ",
    "energySaving": "Энергосбережение  ",
    "signalSourceSwitching": "Источник входа  ",
    "other": "Другие функции:  ",
    "otherFunction": "Функция  ",
    "send": "Отправить  ",
    "ON": "ВКЛЮЧИТЬ  ",
    "OFF": "ВЫКЛЮЧИТЬ  ",
    "btnAddSchedule": "Восстановить  ",
    "EditSchedulelist": "Редактировать расписание  ",
    "AddSchedulelist": "Добавить расписание  ",
    "RestoreSchedulelist": "Восстановить  ",
    "btn": "Отменить  ",
    "btnNewList": "Новое расписание  ",
    "ListName": "Имя  ",
    "Cannotquit": "Обязательно  ",
    "NOCannotquit": "НЕТ  ",
    "ListValidityPeriod": "Период действия  ",
    "ListDescription": "Описание  ",
    "currentSchedule": "Список расписаний  ",
    "historySchedule": "Список истории  ",
    "selectTime": "Время  ",
    "taskType": "Тип задачи  ",
    "selectBroadcasting": "Трансляция  ",
    "selectDeviveControl": "Управление устройством  ",
    "newSchedule": "Новая задача  ",
    "newChecklist": "Новый чек-лист  ",
    "titleStatus": "Статус  ",
    "titleType": "Тип  ",
    "titleStartTime": "Время начала  ",
    "titleEndTime": "Время окончания  ",
    "titleRepeat": "Повторить  ",
    "titleName": "Имя  ",
    "titleAction": "Действие  ",
    "tableEnabled": "Включено  ",
    "tablePaused": "На паузе  ",
    "tableEdit": "Редактировать  ",
    "tableDelete": "Удалить",
    "tableVolumeEdit": "Громкость трансляции  ",
    "tableBroadcastTitle": "Название  ",
    "tableBroadcastContent": "Содержание  ",
    "tableBroadcastList": "Список  ",
    "tableBroadcast": "Обсессивно  ",
    "btnRemoveCompletely": "Полностью удалить  ",
    "btnEnabled": "Включено  ",
    "btnPaused": "На паузе  ",
    "btnDelete": "Удалить  ",
    "repeat0": "ПН  ",
    "repeat1": "ВТ  ",
    "repeat2": "СР  ",
    "repeat3": "ЧТ  ",
    "repeat4": "ПТ  ",
    "repeat5": "СБ  ",
    "repeat6": "ВС  ",
    "dialogTitleAdd": "Новая задача управления устройством  ",
    "dialogTitleEdit": "Редактировать задачу управления устройством  ",
    "newBroadcastingSchedule": "Новая задача трансляции  ",
    "editBroadcastingSchedule": "Редактировать задачу трансляции  ",
    "chooseDevice": "Выбрать устройство  ",
    "timeSetting": "Настройка времени  ",
    "controlBroadcasting": "Опция трансляции  ",
    "controlOption": "Опция управления  ",
    "scheduleName": "Название задачи:  ",
    "destination": "Назначение  ",
    "timeTilte": "Время  ",
    "repeatTitle": "Повторить  ",
    "dialogRepeat0": "ПН  ",
    "dialogRepeat1": "ВТ  ",
    "dialogRepeat2": "СР  ",
    "dialogRepeat3": "ЧТ  ",
    "dialogRepeat4": "ПТ  ",
    "dialogRepeat5": "СБ  ",
    "dialogRepeat6": "ВС  ",
    "dialogOnceType": "Один раз  ",
    "dialogRepeatType": "Повторять  ",
    "mainPower": "Основное питание  ",
    "powerControl": "Управление питанием  ",
    "tableDisplayInputSwitch": "Переключатель входа дисплея  ",
    "tableAirConditioning": "Кондиционер  ",
    "tableProjectionScreen": "Экран проекции  ",
    "tableElectronicLock": "Электрический замок  ",
    "interactiveFlatPanel": "Интерактивная панель с плоским экраном  ",
    "displayInputSwitch": "Переключатель входа дисплея  ",
    "speakerVolume": "Громкость динамиков  ",
    "MICVolume": "Громкость микрофона  ",
    "ProjectionScreen": "Экран проекции  ",
    "ElectronicLock": "Электрический замок  ",
    "AirConditioning": "Кондиционер",
    "AirConditioningPower": "Мощность  ",
    "AirConditioningModel": "Модель  ",
    "AirConditioningTEMP": "TEMP  ",
    "AirConditioningFanSpeed": "Скорость вентилятора  ",
    "OPEN": "ОТКРЫТЬ  ",
    "CLOSE": "ЗАКРЫТЬ  ",
    "UP": "ВВЕРХ  ",
    "DOWN": "ВНИЗ  ",
    "PowerOFF": "ВЫКЛ  ",
    "PowerON": "ВКЛ  ",
    "ModelAuto": "Авто  ",
    "ModelCool": "Охлаждение  ",
    "ModelHeat": "Обогрев  ",
    "ModelAir": "Со стороны воздуха  ",
    "TEMPLow": "Низкий  ",
    "TEMPMiddle": "Средний  ",
    "TEMPHigh": "Высокий  ",
    "btnSave": "Сохранить  ",
    "btnNext": "ДАЛЕЕ  ",
    "StartTime": "Время начала  ",
    "StopTime": "Время остановки  ",
    "Mandatory": "Обязательный  ",
    "Video": "Видео и Аудио  ",
    "Notification": "Уведомление  ",
    "btnFile": "Выберите медиафайл  ",
    "LastingTime": "Продолжительность  ",
    "textTitle": "Заголовок  ",
    "textContent": "Содержание  ",
    "textTitleLetters": "Менее 60 символов  ",
    "textContentLetters": "Менее 320 символов  ",
    "CannotquitYES": "ДА  ",
    "CannotquitNo": "Нет  ",
    "YES": "ДА  ",
    "No": "Нет  ",
    "delTitleContent": "Вы уверены, что хотите удалить этот планировщик?  ",
    "delTitleListContent": "Удаленный планировщик будет перемещен в список истории и может быть восстановлен  ",
    "deleListTitle": "Удалить планировщик?  ",
    "delTitleListContent1": "Удаление планировщика приведет к удалению связанных с ним задач, пожалуйста, подтвердите.  ",
    "deleListTitle1": "Вы уверены, что хотите удалить этот планировщик?  ",
    "delTitle": "Удалить?  ",
    "btnConfirm": "Подтвердить  ",
    "coxAll": "ВСЕ  ",
    "coxBroadcasting": "Трансляция  ",
    "coxDeviveControl": "Управление устройствами  ",
    "rdMandatory": "ДА  ",
    "noRdMandatory": "НЕТ  ",
    "startDate": "Дата начала  ",
    "endedDate": "Дата окончания  ",
    "or": "-  ",
    "broadcastingType": "Тип",
    "ChooseTime": "Выберите время  ",
    "ChooseDate": "Выберите дату  ",
    "newScheduleList": "Новый график  ",
    "editScheduleList": "Редактировать график  ",
    "listName": "Имя  ",
    "listValidityPeriod": "Период действия  ",
    "listDescription": "Описание  ",
    "cancel": "Отменить  ",
    "confirm": "Подтвердить  ",
    "save": "Сохранить  ",
    "addSuccess": "Успешно добавлено!  ",
    "addError": "Не удалось добавить!  ",
    "editSuccess": "Успешно отредактировано!  ",
    "editError": "Не удалось отредактировать!  ",
    "delSuccess": "Успешно удалено!  ",
    "delError": "Не удалось удалить!  ",
    "restoreSuccess": "Список расписаний успешно восстановлен  ",
    "restoreError": "Не удалось восстановить список расписаний  ",
    "restoreTitleContent": "Это время конфликтует с расписанием в списке, выберите снова  ",
    "Enabled": "Включено  ",
    "Paused": "Приостановлено  ",
    "Title": "Заголовок:  ",
    "Content": "Содержание:  ",
    "errorScheduleNameRequired": "Имя задачи должно быть заполнено  ",
    "errorDeviceRequired": "Пожалуйста, выберите целевое устройство  ",
    "deleTitle": "Вы уверены, что хотите удалить эту задачу?  ",
    "loopList": "Список повторений  ",
    "errorPleaseDateRange": "Пожалуйста, выберите диапазон дат  ",
    "addError_2009": "Дублирующее имя расписания  ",
    "conflicts": "Время задачи конфликтует с следующими:  ",
    "Pleaseagain": "Пожалуйста, введите снова  ",
    "errorScheduleName": "Имя задачи  ",
    "errorListName": "Имя расписания  ",
    "today": "Сегодня  ",
    "yesterday": "Вчера  ",
    "thisWeek": "На этой неделе  ",
    "lastWeek": "На прошлой неделе  ",
    "lastMonth": "В прошлом месяце  ",
    "thisMonth": "В этом месяце  ",
    "times": "Раз  ",
    "TimeConflicts": "Конфликты времени  ",
    "editError_2006": "Устройство не найдено  ",
    "editError_2010": "Дублирующее имя задачи  ",
    "ListTimeExpired": "Время расписания истекло, выберите снова  ",
    "TimeExpired": "Время истекло  ",
    "ControlOption": "Отсутствует параметр управления  ",
    "Pleaseleastone": "Пожалуйста, выберите хотя бы один параметр управления  ",
    "Enter": "Ввод  ",
    "TitleFilled": "Заголовок должен быть заполнен  ",
    "ContentFilled": "Содержание должно быть заполнено  ",
    "PleaseMediaFile": "Пожалуйста, выберите медиаприложение  ",
    "PleaseSchedule": "Пожалуйста, выберите задачу  ",
    "delTitleScheduleContent": "Удаленную задачу нельзя восстановить.  ",
    "deleTitleSchedule": "Вы уверены, что хотите удалить эту задачу?  ",
    "deleteScheduleTitle": "Пожалуйста, выберите задачу для удаления  ",
    "PleaseFillColumn": "Пожалуйста, заполните имя расписания  ",
    "PleaseDate": "Пожалуйста, выберите дату  ",
    "Previous": "Предыдущий  ",
    "RemoteControl": "Пульт дистанционного управления  ",
    "taskhasexpired": "Эта задача истекла, пожалуйста, свяжитесь с создателем для обновления времени.  ",
    "execute": "Выполнить  ",
    "broadcastingList": "Список трансляции  ",
    "volumeSuccess": "Уровень громкости успешно установлен  ",
    "volumeFailed": "Не удалось установить уровень громкости  "
  },
  "Automation": {
    "nameDuplicate": "Автоматическое дублирование имени задачи  ",
    "Automation": "Автоматизация  ",
    "if": "Если:  ",
    "ifContent": "Раздел \"ЕСЛИ\" позволяет установить условия на основе данных с датчиков. Выберите датчик и укажите условия, такие как 'Температура > 26°C'.  ",
    "then": "Тогда:  ",
    "thenContent": "Раздел \"ТОГДА\" позволяет выбрать устройства и определить действия для них. Выберите устройства, такие как NMP1, NMP2, и укажите действия, такие как 'Включить + Охлаждение' для кондиционеров.  ",
    "btnDelete": "Удалить  ",
    "Add": "Добавить  ",
    "taskName": "Название задачи  ",
    "dialogTaskName": "Название задачи:  ",
    "Statue": "Статус  ",
    "DevicesApplied": "Примененные устройства  ",
    "Operation": "Операция  ",
    "AirConditioningPower": "Питание  ",
    "AirConditioningModel": "Модель  ",
    "AirConditioningFanSpeed": "Скорость вентилятора  ",
    "bold": "Качание  ",
    "selectTask": "Пожалуйста, выберите задачу  ",
    "autoTaskAdd": "Добавить задачу автоматизации  ",
    "autoTaskEdit": "Редактировать задачу автоматизации  ",
    "Destination": "Назначение  ",
    "selectConditions": "Пожалуйста, укажите действие, которое вы хотите выполнить.  ",
    "selectDestination": "Пожалуйста, выберите целевое устройство NMP, затем укажите действие, которое вы хотите выполнить  ",
    "AirConditioningTEMP": "Температура  ",
    "AirConditioningHumidness": "Влажность  ",
    "noData": "Задач еще не добавлено. Нажмите кнопку \"Добавить\", чтобы добавить задачи.  "
  },
  "rs232Translation": {
    "reliveBinding": "Отвязать  ",
    "RELIVEBINDING": "Отвязать",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "Имя CBX не может быть пустым  ",
    "BrandNoNull": "Бренд не может быть пустым  ",
    "ModelNoNull": "Модель не может быть пустой  ",
    "AcNoNull": "Управление кондиционером не может быть пустым  ",
    "RcNoNull": "Дистанционное управление не может быть пустым"
  },
  "route": {
    customize: 'Настроить',
    "InputSourcesLinkage": "Связка входных источников  ",
    "Automation": "Автоматизация  ",
    "dashboard": "Dashboard",
    "i18n": "I18n  ",
    "organizationMge": "Группы  ",
    "userMge": "Пользователи  ",
    "authorityMge": "Разрешения  ",
    "roleMge": "Роли  ",
    "equipmentMge": "Устройства  ",
    "workstationMge": "Медиа-сервер  ",
    "cloudDiskMge": "Хранение",
    "operationLog": "Журнал операций  ",
    "setting": "Настройки  ",
    "resourceMge": "Управление ресурсами  ",
    "storageMge": "Управление хранилищем  ",
    "interfaceRename": "Переименование интерфейса  ",
    "processorManager": "Менеджер процессора  ",
    "projectorCode": "Управление серийными номерами  ",
    "projectorCodeSetting": "Настройки серийных номеров  ",
    "RepairLog": "Журнал ремонта  ",
    "remoteControl": "Код пульта дистанционного управления  ",
    "acCode": "Код управления кондиционером  ",
    "cardMge": "Карты  ",
    "cardLog": "Журнал использования карт  ",
    "cardManager": "Менеджер карт  ",
    "meetingManager": "Совещания  ",
    "meetingRoomManager": "Управление помещениями  ",
    "meetingDoorManager": "Управление панелями"
  },
  "navbar": {
    "logOut": "Выйти  ",
    "dashboard": "Панель управления  ",
    "screenfull": "Полный экран  ",
    "language": "Язык  ",
    "userConsole": "Консоль Q-NEX  ",
    "BackTianwa": "Вернуться в Tianwa"
  },
  "feedback": {
    "Feedback": "Отзыв  ",
    "email": "Пожалуйста, оставьте свой email для нашего отзыва.  ",
    "content": "Добро пожаловать и оставьте сообщения для улучшения наших продуктов. Спасибо за ваши комментарии.  ",
    "submit": "Отправить  ",
    "emailNoEmpty": "E-mail не может быть пустым  ",
    "emailTrueRule": "Пожалуйста, введите правильный формат email  ",
    "contentNoEmpty": "Содержание не может быть пустым  ",
    "feedbackSuccess": "Успешный отзыв  ",
    "feedbackFailed": "Ошибка при отправке отзыва  ",
    "emailNoChinese": "Почтовый ящик не может содержать китайские символы  ",
    "emailLength": "Длина от 5 до 100 символов  ",
    "GroupNameLength": "Длина от 1 до 20 символов  ",
    "emailSpecialString": "Это поле ввода не может содержать специальные строки"
  },
  "login": {
    "title": "ДОБРО ПОЖАЛОВАТЬ  ",
    "logIn": "Войти  ",
    "username": "Имя пользователя  ",
    "password": "Пароль  ",
    "any": "любой  ",
    "thirdparty": "Или войдите через  ",
    "thirdpartyTips": "Невозможно смоделировать локально, поэтому объедините свою собственную бизнес-симуляцию!!!  ",
    "placeholder": "[  \n  \"Имя пользователя\",  \n  \"Пароль\",  \n  \"Код подтверждения\"  \n]  ",
    "userNameTitle": "Неверное имя пользователя!  ",
    "forget": "Забыли?  ",
    "loginTitle0": "Успешный вход!  ",
    "loginTitle1000": "Неверное имя пользователя или пароль!  ",
    "loginTitle1001": "Имя пользователя и пароль должны быть заполнены!  ",
    "loginTitle1002": "Код подтверждения должен быть заполнен!  ",
    "loginTitle1003": "Статус пользователя недопустим, вход не удался!  ",
    "loginTitle1004": "Ошибка кода подтверждения!  ",
    "loginTitle1005": "Не авторизованы, пожалуйста, войдите сначала!  ",
    "loginTitleUserName": "Имя пользователя должно быть заполнено!  ",
    "loginTitlePwd": "Пароль должен быть заполнен!  ",
    "loginTitleVercode": "Код подтверждения должен быть заполнен!  ",
    "errorLogin": "Недостаточно прав пользователя, вход невозможен!  ",
    "titleLoginNameFormat": "Должно состоять из символов или символов и цифр."
  },
  "organizationMge": {
    "CanTDragTop": "Невозможно перейти в корень  ",
    "prefixCannotBeEmpty": "Префикс учетной записи суперадминистратора не может быть пустым  ",
    "enterEnglishLetters": "Префикс учетной записи суперадминистратора может содержать только английские буквы и цифры  ",
    "dateNotSelected": "Не выбрана дата начала периода действия услуги потоковой передачи  ",
    "btnAddChild": "Добавить подчиненного  ",
    "btnAddSibling": "Добавить брата  ",
    "title": "Подсказка:  ",
    "againTitle": "Пожалуйста, подтвердите снова:  ",
    "sort": "Сортировать:  ",
    "realName": "Полное имя:  ",
    "titleShooleRq": "Это поле должно быть заполнено  ",
    "titleShooleNub": "менее 100 символов  ",
    "schoolName": "Название группы:  ",
    "type": "Тип группы:  ",
    "accountPrefix": "Административная учетная запись:  ",
    "organization": "Дистрибьютор  ",
    "terminalMechanism": "Конечный пользователь  ",
    "equipmentNum": "Номер устройства:  ",
    "organizationNum": "Количество терминальных групп:  ",
    "adminName": "Административная учетная запись:  ",
    "adminPwd": "Пароль администратора:  ",
    "edit": "Редактировать  ",
    "add": "Добавить  ",
    "del": "Удалить  ",
    "addSuccess": "Успешно добавлено  ",
    "addError": "Не удалось добавить!  ",
    "editSuccess": "Успешно изменено  ",
    "editError": "Не удалось изменить!  ",
    "delSuccess": "Удалено успешно!  ",
    "delWarn": "Невозможно удалить эту группу с привязанными устройствами  ",
    "delError": "Не удалось удалить!  ",
    "cancel": "Отменить  ",
    "confirm": "Подтвердить  ",
    "save": "Сохранить  ",
    "TrialWorkstation": "Вы находитесь в тестовом режиме, и вы можете передавать и транслировать в прямом эфире только на 3 терминальных устройства.  ",
    "Normal": "Нормально  ",
    "NormalWorkstation": "Период действия вашей услуги потоковой передачи с  ",
    "to": "по  ",
    "Advent": "Адвент  ",
    "AdventWorkstationOne": "Срок действия вашей услуги потоковой передачи истечет  ",
    "AdventWorkstationTwo": ", пожалуйста, свяжитесь с вашим агентом, чтобы продлить вовремя для нормального использования.  ",
    "Expired": "Истекший  ",
    "ExpiredWorkstation": "Ваш сервис потокового вещания истек, пожалуйста, свяжитесь с вашим агентом для своевременного продления.  ",
    "admin": "Администратор:  ",
    "serviceState": "Сервис потокового вещания:  ",
    "serviceStateLIST": "Сервис потокового вещания  ",
    "ValidityPeriod": "Период действия:  ",
    "ValidityPeriodLIST": "Период действия  ",
    "Trial": "Тестовый  ",
    "Permanent": "Постоянный  ",
    "AnnualBilling": "Годовая оплата  ",
    "mediaValidityPeriod": "Период действия:  ",
    "mediaValidityPeriodLIST": "Период действия  ",
    "contactInformation": "Контактные данные (для напоминания о продлении сервиса потокового вещания)  ",
    "company": "Название компании:  ",
    "email": "Электронная почта:  ",
    "phone": "Телефон:  ",
    "StartDate": "Дата начала  ",
    "EndDate": "Дата окончания  ",
    "To": "До  ",
    "TerminalName": "Имя конечного пользователя  ",
    "Competence": "Администратор  ",
    "operate": "Операция  ",
    "statusFilter": "Фильтр состояния  ",
    "disableStreaming": "Вы уверены, что хотите отключить сервис потокового вещания?  ",
    "enableStreaming": "Вы уверены, что хотите включить сервис потокового вещания?  ",
    "disableStreamingContent": "Когда сервис потокового вещания отключен, группа не сможет использовать связанные функции вещания и прямых трансляций.  ",
    "enableStreamingContent": "Пожалуйста, измените период действия для групп с истекшим сервисом потокового вещания.  ",
    "search": "Введите название организации  ",
    "optionsYearZero": "Пожалуйста, выберите",
    "optionsYearOne": "Один год  ",
    "optionsYearTwo": "Два года  ",
    "optionsYearThree": "Три года  ",
    "dialogName": "Имя:  ",
    "detTitle": "Удаление группы приведет к удалению всего содержимого, связанного с ней.  ",
    "groupDelTitle": "Вы уверены, что хотите удалить эту группу?  ",
    "delTitle": "Удалить?  ",
    "delTitleContent": "Выбранное содержимое будет удалено из базы данных. Это действие нельзя отменить. Вы уверены, что хотите продолжить?  ",
    "delCancelButton": "Отмена  ",
    "delConfirmButton": "Подтвердить  ",
    "copySuccess": "Контент был скопирован в буфер обмена.  ",
    "copyError": "Браузер не поддерживает автоматическое копирование  ",
    "error1200": "Дублированное имя группы  ",
    "error1201": "Дублирование группы или ID группы  ",
    "error1202": "Превышено максимальное количество подключаемых устройств  ",
    "error1203": "Дублированный имя пользователя  ",
    "error1204": "Группа с таким же именем существует на том же уровне  ",
    "error1210": "Пожалуйста, введите пароль администратора  ",
    "warningGroup": "Выберите группу!  ",
    "warningTerminal": "Группа терминала не может создавать подгруппы!  ",
    "account": "Дублированный аккаунт  ",
    "titleOrganization": "Примечание: Префикс учётной записи задаётся на уровне организации. Все учётные записи пользователей в этой организации будут использовать один и тот же префикс.",
    "all": "Все"
  },
  "userMge": {
    "nickName": "Псевдоним  ",
    "contentWithBrand": "Введите марку или модель  ",
    "contentwithIp": "Поиск по имени устройства или IP-адресу.  ",
    "btnAdd": "Новый пользователь  ",
    "btnDelete": "Удалить  ",
    "btnDownload": "Загрузить шаблон  ",
    "btnImport": "Массовый импорт  ",
    "btnExport": "Скачать  ",
    "btnDisable": "Отключить  ",
    "btnEnable": "Включить  ",
    "accountType": "Фильтровать по роли  ",
    "organizationName": "Фильтровать по группе  ",
    "content": "Поиск  ",
    "systemAccount": "ID пользователя  ",
    "idCardNumber": "ID сотрудника  ",
    "customizeAccount": "Пользовательская учетная запись  ",
    "userName": "Имя  ",
    "licenseNum": "Номер лицензии  ",
    "phone": "Телефон  ",
    "email": "Электронная почта  ",
    "role": "Роль  ",
    "status": "Статус  ",
    "affiliatedOrganization": "Группы  ",
    "roleTypeList1": "Обычный пользователь  ",
    "roleTypeList2": "Студент  ",
    "roleTypeList3": "Родитель  ",
    "roleTypeList101": "Администратор агента  ",
    "roleTypeList102": "Администратор  ",
    "roleTypeList301": "Супер администратор  ",
    "userStatus1": "Активен  ",
    "userStatus2": "Заблокирован  ",
    "userStatus3": "Удалить  ",
    "operate": "Действия  ",
    "dialogName": "Псевдоним:  ",
    "dialogUserName": "ID пользователя:  ",
    "dialogUserNameDefined": "Имя пользователя:  ",
    "dialogPassword": "Пароль:  ",
    "dialogID": "ID сотрудника:  ",
    "dialogRole": "Роль:  ",
    "dialogEmail": "Электронная почта:  ",
    "dialogPhone": "Телефон:  ",
    "dialogGroup": "Группа:  ",
    "addUser": "Новый пользователь  ",
    "editUser": "Редактировать пользователя  ",
    "addSuccess": "Успешно добавлено!  ",
    "addError": "Не удалось добавить!  ",
    "editSuccess": "Успешно отредактировано!  ",
    "editError": "Не удалось отредактировать!  ",
    "delSuccess": "Удалено успешно!",
    "delError": "Ошибка при удалении!  ",
    "cancel": "Отменить  ",
    "confirm": "Подтвердить  ",
    "save": "Сохранить  ",
    "tableDel": "Удалить  ",
    "tableEdit": "Редактировать  ",
    "selectRoles": "Выбрать роли  ",
    "delTitle": "Удалить?  ",
    "delTitleContent": "Выбранный контент будет удален из базы данных. Эта операция необратима. Вы уверены, что хотите продолжить?  ",
    "delCancelButton": "Отменить  ",
    "delConfirmButton": "Подтвердить  ",
    "titleRealNameRq": "Это поле обязательно для заполнения  ",
    "titleRealNameFormat": "Выберите имя пользователя, состоящее только из букв и цифр.  ",
    checkPasswordTitleTwo: 'Установите пароль длиной не менее 6 символов, содержащий буквы и цифры. Специальные символы разрешены (без ограничений).',
    checkPasswordTitle: 'Пароль должен содержать не менее 6 символов и не может состоять только из цифр',
    "titlePhoneFormat": "Номер телефона может содержать только цифры, (), + и -.  ",
    "phoneFilled": "Номер телефона должен быть заполнен.  ",
    "titleEmaileFormat": "Ошибка формата электронной почты.  ",
    "emaileFilled": "Электронная почта должна быть заполнена.  ",
    "titlUserNameDefinedNub": "Имя пользователя не может содержать более 30 символов  ",
    "titlRealNameNub": "Имя не может содержать более 30 символов.  ",
    "titlRealNameField": "Имя обязательно для заполнения.  ",
    "thisPasswordField": "Пароль должен быть заполнен.  ",
    "titlPassWordNub": "Пароль должен содержать от 6 до 30 символов  ",
    "enableStatus": "Активировать пользователя  ",
    "stopStatus": "Отключить пользователя  ",
    "enableContent": "Вы уверены, что хотите активировать пользователя?  ",
    "stopContent": "Вы уверены, что хотите отключить пользователя?  ",
    "error1400": "Имя пользователя уже существует, попробуйте снова  ",
    "error1401": "ID пользователя уже существует, операция не удалась!  ",
    "error1402": "Группа не существует, импорт не удался!  ",
    "error1403": "Неверные данные  ",
    "error1404": "Недостаточные права  ",
    "selUser": "Пожалуйста, выберите пользователя!  ",
    "error1405": "Ошибка при получении роли  ",
    "error1406": "Неверный формат данных импортированного пользователя  ",
    "error1407": "Электронная почта уже существует, операция не удалась.  ",
    "error1408": "Номер телефона уже существует, операция не удалась.  ",
    "error1900": "Параметр пустой  ",
    "error1610": "Пожалуйста, используйте роль администратора терминала для выполнения связанных операций  ",
    "errorOrgIdList": "Группа не может быть пустой!  ",
    "Bindsucceeded": "Связывание успешно  ",
    "Bindfailed": "Не удалось привязать  ",
    "tableuserName": "Имя пользователя  ",
    "titleDevice": "Устройство  ",
    "bindDevice": "Привязанное устройство  ",
    "Bindcontrollable": "Привязать управляемое устройство сейчас?  "
  },
  "devicesMge": {
    mustChooseOne: 'При выборе интеллектуального пульта дистанционного управления необходимо выбрать хотя бы одну управляющую команду',
    customName: 'Пользовательское имя',
    "testAcCode": "Тест нового кода управления A/C",
    "Online": "Онлайн",
    "Offline": "Офлайн",
    "unBindConfirm": "Подтвердите отмену привязки Serial",
    "unBindConfirm485": "Подтвердите отмену привязки RS485",
    "notYetBoundRS232": "Устройство еще не связано с кодом Serial. Вы можете перейти в Устройство > Код управления Serial, чтобы добавить его.",
    "RsFollowingFunctions": "Можно выполнить следующие функции через коды Serial:",
    "Unbind": "Отвязать",
    "Limit255": "Имя файла может содержать не более 255 символов",
    "clear": "Очистить",
    "equipName": "Имя устройства",
    "equipType": "Тип",
    "selectField": "Выберите файл",
    "dialogTip": "* Содержимое слева отображается по умолчанию, если поле ввода справа пусто",
    "dialogTipSingle": "* Если только одно устройство не имеет имени, используйте имя \"ВСЕ\"",
    "cantDelTemplateOne": "The CBX of ",
    cantDelTemplateTwo: 'CBX устройства «{deviceName}» является шаблоном. Вы уверены, что хотите удалить его?',
    "templateTitle": "Замена шаблона",
    "templateContentOne": "The device name \"",
    "templateContentTwo": "\" has been set as the common CBX template. Are you sure to set the current device as the template?",
    "vcbNoTemplateNoSave": "Невозможно сохранить без шаблона",
    "vcbAcControl": "Выберите устройство A/C",
    "vcbRemoteControl": "Выберите устройство для дистанционного управления",
    "vcbPOWERControl": "Управление питанием",
    "vcbRS232Control": "Управление Serial",
    "vcbIRControl": "Управление IR",
    "vcbSetting": "Настройки CBX",
    "editVcb": "Редактирование CBX",
    "vcbName": "Имя CBX",
    "iot": "Управление CBX",
    "saveAsTemplate": "Сохранить как шаблон",
    saveAsTemplatereplenish: 'Выберите несколько устройств, чтобы использовать этот шаблон в Центре управления',
    "Upload": "Загрузить",
    "Select": "Выбрать",
    "InputDeviceID": "Введите ID устройства",
    "editNameTips": "* Содержимое слева отображается по умолчанию, если поле ввода справа пусто.",
    "_RS232A": "Интерфейс один",
    "_RS232B": "Интерфейс два",
    "institutionDirectory": "Каталог учреждения",
    "projectionScreenLinkageSetting": "Настройки управления экраном проекции",
    "screenLiftingLinkageDisplaySwitch": "Управление связью экрана проекции и отображения:",
    "stopLinkage": "Отключить (Управление экраном проекции отдельно)",
    "Enable": "Включить (Синхронное управление экраном проекции и отображением)",
    "btnAddDevice": "Добавить устройство",
    "btnImportDevice": "Массовый импорт устройств",
    "btnDel": "Удалить",
    "btnEdit": "Редактировать",
    "tableIpAddress": "IP-адрес",
    "MACAddress": "MAC-адрес",
    "firmwareVersion": "Версия прошивки",
    "NA": "Не доступно",
    "tableDeviceName": "Имя устройства",
    "tableStatus": "Статус",
    "tableVideoSwitch": "Переключатель видео",
    "tableAudio": "Распределение A/V",
    "tablePowerControl": "Управление питанием",
    "tableRS232": "Серийное управление",
    "tableIR": "IR-управление",
    "tableRFIDCard": "IC-карта",
    "tableControlPanel": "Панель управления",
    "tableOrganization": "Группы",
    "tableActions": "Действия",
    "dialogAddTitle": "Добавить устройство",
    "dialogEditTitle": "Редактировать устройство",
    "dialogBatchAddTitle": "Массовое добавление устройств",
    "dialogBatchEditTitle": "Массовое редактирование устройств",
    "btnCancel": "Отменить",
    "Devices": "Устройства:",
    "ProjectorCode": "Код Serial:",
    "Group": "Группа:",
    "btnBatchAdd": "Массовое добавление",
    "delTitle": "Удалить?",
    "delTitleContent": "Выбранные компоненты будут удалены из базы данных. Этот процесс необратим. Вы уверены, что хотите продолжить?",
    "delCancelButton": "Отменить",
    "delConfirmButton": "Подтвердить",
    "addError": "Не удалось добавить!",
    "editSuccess": "Успешно отредактировано!",
    "editError": "Не удалось отредактировать!",
    "delSuccess": "Удалено успешно!",
    "delError": "Не удалось удалить!",
    "content": "Поиск",
    "cancel": "Отменить",
    "confirm": "Подтвердить",
    "save": "Сохранить",
    "tableDel": "Удалить",
    "tableEdit": "Редактировать",
    "selectRoles": "Выбрать роли",
    "selectType": "Пожалуйста, выберите тип",
    "selectDevices": "Пожалуйста, выберите устройство",
    "titleRealNameRq": "Это поле должно быть заполнено",
    "titleRealNameNub": "Менее 100 символов",
    "titlPassWordNub": "Менее 15 символов",
    "error1900": "Полученный параметр пуст",
    "error2000": "Превышено максимальное количество подключаемых устройств",
    "error2001": "Импортированный код устройства неверен или еще не был введен в систему.",
    "error2002": "Дублированное имя устройства импортировано",
    "error2003": "Импортированный идентификатор устройства уже используется",
    "error2004": "Ошибка импорта данных",
    "error2005": "Название бренда или модели совпадает с уже имеющимися данными в системе; пожалуйста, переименуйте бренд или модель.",
    "error2008": "Это устройство уже связано с другой группой",
    "notDevicesName": "Имя устройства не может быть пустым",
    "notDevicesNO": "Идентификатор устройства не может быть пустым",
    "dialogDevicesName": "Название устройства:",
    "dialogDevicesID": "ID устройства:",
    "dialogProjectorCode": "Код Serial:",
    "dialogGroup": "Группа:",
    "dialogSel": "Пожалуйста, выберите",
    "errorOrgIdList": "Группа не может быть пустой!",
    "errorDevicesName": "Название устройства не может быть пустым!",
    "errorDevicesNo": "ID устройства не может быть пустым!",
    "dialogTiltleDevices": "Устройства:",
    "uploadSuccess": "Загрузка прошла успешно",
    "addSuccess": "Добавление прошло успешно",
    "ChooseGroups": "Выберите группы",
    "ChooseIcon": "Выберите иконку",
    "dialogDevicesTitle": "Настройки параметров применяются к следующим устройствам",
    "backDevice": "Назад",
    "bootSetting": "Опции запуска",
    "nmpOpenSetting": "Настройки включения",
    "npsOpenSetting": "Настройки включения",
    "nmpPowerSettings": "Настройки питания",
    "npsPowerSettings": "Настройки питания",
    "nmpInterfaceSettings": "Настройки интерфейса",
    "npsInterfaceSettings": "Настройки интерфейса",
    "nmpDefaultChannel": "Настройки канала по умолчанию",
    "nmpCloseSetting": "Настройки выключения",
    "npsCloseSetting": "Настройки выключения",
    "SwipeToStart": "Включить блокировку (прикоснитесь к карте для разблокировки)",
    "ControlPanelToStart": "Отключить блокировку (неограниченная операция)",
    "Display": "Отображение",
    "External": "Внешнее",
    "startingUpMethod": "Включить/выключить блокировку панели:",
    "startWith": "Запуск с:",
    "nmpstartWith": "Синхронное включение:",
    "nmpcloseWith": "Синхронное выключение:",
    "RS232Tip": "Когда основное питание выключается, всего 5 интерфейсов Serial, включая Serial и до 4 CBX, получат соответствующий код команды отключения.",

    startPowerTip: 'При включении активируются все устройства, подключённые к интерфейсам питания CBX.',
    startAirTip: 'При включении все связанные кондиционеры включаются через инфракрасный порт устройства/CBX.',
    startIrTip: 'При включении отправляется командa управления по инфракрасному каналу устройства/CBX (например, опускание экрана, включение проектора).',
    startRSTip: 'При включении отправляется команда включения через интерфейс Serial устройства/CBX.',
    CloseDisplayTip: 'Устройства, подключённые к порту DISPLAY, автоматически выключаются при выключении NDP/NMP. Этот параметр управляется прошивкой и не может быть изменён через программное обеспечение.',
    CloseExternalTip: 'Устройства, подключённые к порту EXTERNAL, автоматически выключаются при выключении NDP/NMP. Этот параметр управляется прошивкой и не может быть изменён через программное обеспечение.',
    ClosePowerTip: 'При выключении отключаются все устройства, подключённые к интерфейсам питания CBX.',
    CloseAirTip: 'При выключении все связанные кондиционеры выключаются через инфракрасный порт устройства/CBX.',
    CloseIrTip: 'При выключении отправляется командa управления по инфракрасному каналу устройства/CBX (например, подъём экрана, выключение проектора).',
    CloseRSTip: 'При выключении отправляется команда выключения через интерфейс Serial устройства/CBX.',
    npsOpenRS232Tip: 'Когда основное питание включено, два последовательных порта NPS получат соответствующие командные коды включения.',
    "npsRS232Tip": "Когда основное питание выключается, два интерфейса Serial на NPS получат соответствующие коды команды отключения.",
    "useCardTip": "После разблокировки карты питание устройств будет автоматически активировано.",
    "npsCardTip": "После разблокировки карты основное питание устройств будет автоматически активировано.",
    "PowerOutageHandling": "Обработка отключений питания",
    "PowerOutageHandTip": "Для продолжения доступа при неожиданном отключении питания выберите 'Разблокировать при отключении питания'. В противном случае выберите 'Блокировать при отключении питания', чтобы ограничить доступ.",
    "acSetting": "Настройки кондиционера",
    "ChooseType": "Тип устройства",
    "ChooseBrand": "Выберите бренд",
    "ChooseModel": "Выберите модель",
    "btnConnectingTest": "Тест соединения",
    "LockSetting": "Настройки электрического замка",
    "ElectricLockType": "Тип электрического замка:",
    "PowerUNLOCK": "Разблокировка при отключении питания",
    "PowerLOCK": "Блокировка при отключении питания",
    "none": "Отсутствует",
    "oddParity": "Нечетная четность",
    "EvenParity": "Четная четность",
    "LastSetting": "Последняя настройка",
    "ElectricLockClosing": "Закрытие электрического замка:",
    "manualSwitch": "Ручной переключатель",
    "Auto": "Авто (в",
    "projectorSetting": "Выбор и привязка устройств",
    "baudRate": "Скорость передачи",
    "Parity": "Четность",
    "ON": "Включить",
    "OFF": "Выключить",
    "Channel1": "Канал 1",
    "Channel2": "Канал 2",
    "PowerOffDelay": "Задержка выключения",
    "second": "с",
    "DefaultChannel": "Основной канал",
    "HDMIA": "HDMI выход A:",
    "HDMIB": "HDMI выход B:",
    "HDMIC": "HDMI выход C:",
    "btnSaveApply": "Сохранить и применить к...",
    "btnSave": "Сохранить",
    "btnCustomize": "Пользовательский",
    "ACIsPowerTitle": "Проверить, включен ли кондиционер?",
    "ACIsPowerContent": "Пожалуйста, выключите кондиционер перед тестированием. Если он не включается, убедитесь, что марка и модель кондиционера правильные.",
    "btnNextModel": "Нет, протестировать следующую модель",
    "btnYes": "Да",
    "errorConnecting": "Не удалось подключить",
    "hot": "ГОРЯЧИЙ",
    "_MAGNETICLOCK": "Электронный замок",
    "_AIR": "Кондиционер",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "Настройка IR управления",
    "acControlTitle": "Выберите устройство A/C:",
    "acControlTitleNew": "Устройство A/C",
    "intelligentControlTitle": "Выберите устройство дистанционного управления:",
    "intelligentControlTitleNew": "Устройство дистанционного управления",
    "btnACControlCode": "Идентифицировать новый код управления A/C",
    "btnAddRemoteControl": "Новый код пульта дистанционного управления",
    "ACControlCodeTitle": "Идентифицировать код управления A/C",
    "ACControlCodeseft1": "Идентифицировать код",
    "ACControlCodeseft2": "Добавить информацию",
    "btnStartIdentify": "Запуск",
    "Identifysuccess": "Идентификация прошла успешно!",
    "BeingIdentify": "Анализ...",
    "acBrand": "Марка кондиционера",
    "acModel": "Модель кондиционера",
    "IdentifyFailureTitle": "Не удалось найти код",
    "IdentifyFailureContent": "Идентификация не удалась, эта модель в настоящее время не поддерживается. Попробуйте пульт дистанционного управления",
    "btnTryAgain": "Попробовать снова",
    "btnJump": "Перейти к пульту дистанционного управления",
    "ACrideo": "A/C",
    "ortherRideo": "Другие устройства",
    "btnBack": "Назад",
    "btnSortOut": "Перейти к редактированию",
    "remoteControlSeft1": "Выберите тип устройства",
    "remoteControlSeft2": "Изучить код",
    "remoteControlSeft3": "Добавить информацию",
    "addRemoteControlError": "Извините, не удается выучить больше кодов. Пожалуйста, сначала отредактируйте существующие коды пульта",
    "btnPrevious": "Предыдущий",
    "btnNextStep": "Следующий",
    "remoteControlErrorTitle": "Не удалось выучить код",
    "remoteControlErrorContent1": "1. Инфракрасный передатчик не заблокирован",
    "remoteControlErrorContent2": "2. Нет сильного светового воздействия рядом с приемником",
    "remoteControlErrorContent3": "3. Инфракрасный передатчик установлен правильно",
    "remoteControlErrorContent4": "4. Пульт дистанционного управления работает хорошо",
    "deviceItem1": "A/C",
    "deviceItem2": "Проектор",
    "deviceItem3": "Телевизор",
    "deviceItem4": "Вентилятор",
    "deviceItem5": "Освещение",
    "deviceItem6": "Другие",
    "deviceItem7": "Интерактивная панель",
    "deviceItem8": "Система записи лекций",
    "deviceItem9": "PTZ-камера",
    "RS232protocol": "Протокол Serial:",
    "btnRemoteControl": "Начать обучение",
    "BeingIdentify1": "Анализ...",
    "Identifysuccess1": "Успех",
    "controllerType1": "A/C",
    "controllerType2": "Serial",
    "controllerType3": "TV",
    "controllerType4": "Вентилятор",
    "controllerType5": "Свет",
    "controllerType9": "Другие",
    "rqRemoteControlCode": "Пожалуйста, введите имя кода пульта",
    "rqBrand": "Пожалуйста, введите марку A/C",
    "rqModel": "Пожалуйста, введите модель A/C",
    "error2016": "Имя пульта дублируется, пожалуйста, введите другое",
    "RS232Setting": "Настройки серийного кода",
    "IR232Setting": "Настройки IR",
    "SystemError": "Ошибка системы. Пожалуйста, попробуйте снова",
    "conditionerCodeContent": "Не удается найти код кондиционера, пожалуйста, попробуйте снова",
    "remoteControlCodeContent": "Не удается найти код пульта дистанционного управления, пожалуйста, попробуйте снова",
    "btnRetry": "Повторить",
    "Bindusers": "Привязать пользователя",
    "tablebinduser": "Привязать пользователей",
    "Refresh": "Обновить",
    "Binduserlable": "Привязать пользователей, которые могут управлять устройством сейчас?",
    "SaveApplySuccessfully": "Успешно сохранено и применено",
    "DeviceType": "Тип:",
    "tableDeviceType": "Тип",
    "empty": "Пусто.",
    "sendCommand": "Отправить позже",
    "enable": "Включить",
    "disable": "Отключить",
    "SYNCremoteControl": "СИНХРОНИЗИРОВАТЬ с пультом дистанционного управления",
    "analysisfailed": "Анализ не удался, пожалуйста, попробуйте снова",

    "CBX": {
      "powerSupplyON": "Включить",
      "powerSupplyOFF": "Выключить",
      "powerVcrON": "Начать запись",
      "powerVcrOFF": "Остановить запись",
      "lockScreenON": "Блокировка включена",
      "lockScreenOFF": "Блокировка выключена",
      "childLockON": "Детская блокировка включена",
      "childLockOFF": "Детская блокировка выключена",
      "energySavingON": "Энергосбережение включено",
      "energySaving": "Энергосбережение",
      "energySavingOFF": "Энергосбережение выключено",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "Динамик",
      "brightAdjustment": "Яркость",
      "other": "Другие функции...",
      "volumeExample": "Полная функциональность Serial требуется для полной совместимости с системой записи.",
      "functionCode": "Функция:",
      "Name": "Имя:",
      "controlCode": "Код управления:",
      "brand": "Марка:",
      "model": "Модель:",
      "errorBrandName": "Марка не может быть пустой!",
      "errorModelName": "Модель не может быть пустой!"
    }

  },
  "roleMge": {
    "role1": "Обычный пользователь",
    "role101": "Администратор агента",
    "role102": "Администратор",
    "role4": "Пользовательская роль",
    "roleNew": "Новая роль",
    "btnAddRole": "Добавить роль",
    "chooseUser": "Выбрать пользователя",
    "titleLevel": "Уровень свойств трансляции:",
    "titleSettings": "Настройки разрешений:",
    "btnSave": "Сохранить",
    "btnDelete": "Удалить",
    "cancel": "Отменить",
    "confirm": "Подтвердить",
    "save": "Сохранить",
    "addSuccess": "Успешно добавлено!",
    "addError": "Ошибка при добавлении!",
    "editSuccess": "Успешно отредактировано!",
    "editError": "Ошибка при редактировании!",
    "delSuccess": "Успешно удалено!",
    "delError": "Ошибка при удалении!",
    "V3_0_OrganizationManage": "Управление группами",
    "V3_0_UserManage": "Управление пользователями",
    "V3_0_DeviceManage": "Управление устройствами",
    "V3_0_CloudSpaceManage": "Управление облачным пространством",
    "V3_0_OrganizationManage_View": "Просмотр",
    "V3_0_OrganizationManage_Edit": "Редактировать",
    "V3_0_UserManage_View": "Просмотр",
    "V3_0_UserManage_Edit": "Редактировать",
    "V3_0_DeviceManage_AddDevice": "Добавить устройство",
    "V3_0_DeviceManage_Operating": "Операции",
    "V3_0_DeviceManage_Delete": "Удалить",
    "V3_0_DeviceManage_Edit": "Редактировать",
    "V3_0_CloudSpaceManage_PersonalManage": "Управление личным облаком",
    "V3_0_CloudSpaceManage_PublicManage": "Управление общим облаком",
    "V3_0_CloudSpaceManage_SpaceManage": "Распределение пространства",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Операции",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Просмотр",
    "V3_0_CloudSpaceManage_PublicManage_View": "Просмотр",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Загрузить",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Скачать",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Удалить файл",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Редактировать папку",
    "delTitle": "Удалить?",
    "delTitleContent": "Выбранное содержимое будет удалено из базы данных. Эта операция необратима. Вы уверены, что хотите продолжить?",
    "delCancelButton": "Отменить",
    "delConfirmButton": "Подтвердить",
    "btnAdd": "Добавить роль",
    "RoleName": "Название роли:",
    "ManageRange": "Область управления:",
    "ChooseUser": "Выбрать пользователя:",
    "PermissionSettings": "Настройки разрешений:",
    "BroadcastingPropertyLevel": "Уровень свойств трансляции",
    "ChooseGroups": "Выбрать группы",
    "ChooseTheUser": "Выбрать пользователя",
    "deleleTitle": "Новая роль не была сохранена. Если вы покинете, роль будет удалена. Вы уверены, что хотите покинуть?",
    "Error1601": "Невозможно использовать администратора",
    "Error1602": "Не удалось получить роль разрешений",
    "Error1603": "Только администраторы имеют доступ к этим функциям",
    "Error1604": "Имя роли не может быть пустым",
    "Error1605": "Группа не может быть пустой",
    "Error1606": "Эта роль уже существует",
    "Error1607": "Роль, определенная системой, не может быть изменена",
    "Error1608": "Ошибка при установке роли",
    "Error1609": "Роль общего пользователя системы, изменение не разрешено",
    "Error1610": "Используйте роль администратора терминала для выполнения связанных операций",
    "Error1611": "Не имеет соответствующих прав роли"
  },
  "projectorDevicesMge": {
    "tipOne": "1. Заполните имя функции и код управления. Примеры кодов управления используют формат HEX.",
    "tipTwo": "2. Этот интерфейс предназначен только для настройки серийных команд включения/выключения. Перейдите в 'Управление устройствами / Устройства / Операции / Настройки питания', чтобы включить функцию.",
    "tipFunctionOne": "1. Выберите часто используемые функции из раскрывающегося списка. Соответствующие значки будут отображаться на интерфейсе серийного управления умной панели.",
    "tipFunctionTwo": "2. Команды 'POWER ON' и 'POWER OFF' используются для серийной связи включения/выключения устройства. На этой странице настраиваются только коды управления. Перейдите в 'Управление устройствами / Устройства / Операции / Настройки питания', чтобы включить функцию связи.",
    "ListRS232functions": "Список функций серийного управления",
    "Customizefunctionlist": "Настроить список функций",
    "btnAddProjectorCode": "Добавить серийный код",
    "btnDel": "Удалить",
    "inputSeach": "Поиск",
    "btnEdit": "Редактировать",
    "cancel": "Очистить",
    "confirm": "Подтвердить",
    "tableName": "Имя кода",
    "tablersType": "Тип устройства:",
    "tablersTypeTable": "Тип устройства",
    "tableModel": "Модель",
    "tableBrand": "Марка",
    "tableActions": "Действия",
    "dialogAddTitle": "Добавить код Serial",
    "dialogEditTitle": "Редактировать код Serial",
    "brand": "Название бренда:",
    "model": "Модель:",
    "baudRate": "Скорость передачи:",
    "parity": "Четность:",
    "powerOn": "ВКЛ",
    "powerOff": "ВЫКЛ",
    "pgrInput1": "Канал 1",
    "pgbInput2": "Канал 2",
    "delTitle": "Удалить?",
    "delTitleContent": "Выбранное содержимое будет удалено из базы данных. Это действие нельзя отменить. Вы уверены, что хотите продолжить?",
    "delCancelButton": "Отмена",
    "delConfirmButton": "Подтвердить",
    "content": "Поиск",
    "operate": "Действия",
    "tableDel": "Удалить",
    "tableEdit": "Редактировать",
    "addSuccess": "Успешно добавлено!",
    "addError": "Ошибка добавления!",
    "editSuccess": "Успешно отредактировано!",
    "editError": "Ошибка редактирования!",
    "delSuccess": "Успешно удалено!",
    "delError": "Ошибка удаления!",
    "selectTitle": "Пожалуйста, выберите Serial!",
    "selectCode": "Выбрать Serial",
    "none": "Нет",
    "oddParity": "Нечетная четность",
    "EvenParity": "Четная четность"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "Управление группами",
    "V3_0_UserManage": "Управление пользователями",
    "V3_0_DeviceManage": "Управление устройствами",
    "V3_0_CloudSpaceManage": "Управление облачным пространством",
    "V3_0_OrganizationManage_View": "Просмотр",
    "V3_0_OrganizationManage_Edit": "Редактировать",
    "V3_0_UserManage_View": "Просмотр",
    "V3_0_UserManage_Edit": "Редактировать",
    "V3_0_DeviceManage_AddDevice": "Добавить устройство",
    "V3_0_DeviceManage_Operating": "Операции",
    "V3_0_DeviceManage_Delete": "Удалить",
    "V3_0_DeviceManage_Edit": "Редактировать",
    "V3_0_DeviceManage_RepairLog": "Журнал ремонтов",
    "V3_0_CloudSpaceManage_PersonalManage": "Управление персональным облаком",
    "V3_0_CloudSpaceManage_PublicManage": "Управление публичным облаком",
    "V3_0_CloudSpaceManage_SpaceManage": "Управление облачным пространством",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Операции",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Просмотр",
    "V3_0_CloudSpaceManage_PublicManage_View": "Просмотр",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Загрузить",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Скачать",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Удалить",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Редактировать",
    "delTitle": "Удалить?",
    "delTitleContent": "Выбранные компоненты будут удалены из базы данных. Этот процесс необратим. Вы уверены, что хотите продолжить?",
    "delCancelButton": "Отменить",
    "delConfirmButton": "Подтвердить",
    "content": "Поиск",
    "operate": "Действие",
    "tableDel": "Удалить",
    "tableEdit": "Редактировать",
    "addSuccess": "Добавлено успешно!",
    "addError": "Не удалось добавить!",
    "editSuccess": "Редактирование успешно!",
    "editError": "Не удалось отредактировать!",
    "delSuccess": "Удалено успешно!",
    "delError": "Не удалось удалить!",
    "selectTitle": "Выберите Serial!"
  },
  "workstationMge": {
    "priorChoice": "Предпочтения трансляции:",
    "SpeedPriority": "Приоритет скорости",
    "SyncPriority": "Приоритет синхронизации кадров",
    "SpeedPriorityTip": "После отправки инструкций по трансляции AV, терминалы Q-NEX могут выполнить задачу воспроизведения с более коротким временем буфера около 3-5 секунд. Приоритет скорости настоятельно рекомендуется, когда сервер мультимедиа работает в LAN.",
    "SyncPriorityTip": "После отправки инструкций по трансляции AV, терминалы Q-NEX могут выполнить задачу воспроизведения синхронно с временем буфера около 8-12 секунд.",
    "btnAddMedia": "Добавить медиасервер",
    "btnBack": "Назад",
    "tableMediaLibId": "ID медиасервера",
    "tableMediaLibName": "Название медиасервера",
    "tableState": "Статус сети",
    "tableBindingUsers": "Связанные пользователи",
    "tableLiveAddress": "Адрес трансляции",
    "tableAddress": "Адрес потока",
    "tableOperate": "Действия",
    "tableDel": "Удалить",
    "tableEdit": "Редактировать",
    "titleMediaStation": "Адрес трансляции",
    "titleLiveStation": "Адрес потока:",
    "radioPublic": "Публичный",
    "radioPrivate": "Частный",
    "btnSave": "Сохранить",
    "titleUsers": "Пользователи",
    "titleCanBe": "Можно связать",
    "titleHaveBeen": "Уже связано",
    "titleMore": "Нужно добавить еще?",
    "btnAdd": "Добавить",
    "content": "Поиск",
    "tableName": "Имя",
    "tableUserName": "Имя пользователя",
    "operate": "Действия",
    "affiliatedOrganization": "Группы",
    "dialogTitle": "Добавить новый медиасервер",
    "dialogTitleEdit": "Редактировать новый медиасервер",
    "dialogItemName": "Имя:",
    "dialogItemId": "ID:",
    "dialogItemIp": "Адрес трансляции:",
    "titleSelectUsers": "Выбрать пользователей",
    "selectMedia": "Пожалуйста, выберите медиасервер",
    "delTitle": "Вы уверены, что хотите удалить?",
    "delMediaLibTitle": "Подтверждение удаления?",
    "delTitleContent": "Выбранные элементы будут удалены из базы данных. Это действие необратимо. Вы уверены, что хотите продолжить?",
    "delTitleMediaLibContent": "Действие удаления приведет к удалению соответствующих данных и не может быть отменено.",
    "delCancelButton": "Отмена",
    "delConfirmButton": "Подтвердить",
    "selectDevices": "Пожалуйста, выберите устройства",
    "selectUser": "Пожалуйста, выберите пользователей",
    "addUser": "Добавить пользователя",
    "editUser": "Редактировать пользователя",
    "addSuccess": "Успешно добавлено!",
    "addError": "Не удалось добавить!",
    "editSuccess": "Успешно отредактировано!",
    "editError": "Не удалось отредактировать!",
    "delSuccess": "Успешно удалено!",
    "delError": "Не удалось удалить!",
    "cancel": "Отмена",
    "confirm": "Подтвердить",
    "save": "Сохранить",
    "error2500": "Превышено максимальное количество устройств, которые могут быть подключены к текущей рабочей станции.",
    "DeviceName": "Имя устройства",
    "AssociatedUserManagement": "Управление связанными пользователями",
    "btnDel": "Удалить",
    "errorMsgId": "Не удалось найти этот ID",
    "LiveStreaming": "Адрес трансляции:",
    "NoFoundMediaId": "Не удалось получить ID медиасервера",
    "AlreadyConnectedOrg": "Медиасервер уже связан с другой организацией",
    "AlreadyBoundMedia": "Эта организация уже связала медиасервер и не может привязать еще один",
    "DeleteSecondaryConfirmation": "Данные не могут быть восстановлены после удаления медиасервера, пожалуйста, подтвердите еще раз."
  },
  "cloudDiskMge": {
    "totalStorage": "ОБЩЕЕ ХРАНИЛИЩЕ",
    "GetMore": "Получить больше",
    "StorageSpace": "Место для хранения",
    "Adjustment": "Настройка",
    "moreSpace": "Получить больше места для хранения",
    "PublicStorage": "Общий доступ",
    "PublicStorageUsed": "Использовано общего хранилища",
    "PublicStorageLasted": "Осталось общего хранилища",
    "IndividualStorageUsed": "Использовано личного хранилища",
    "IndividualStorageLasted": "Осталось личного хранилища",
    "storageSpace": "Настройка пространства хранения",
    "tableUserName": "Имя пользователя",
    "tableUsedSpace": "Используемое пространство",
    "tableAvailableSpace": "Доступное пространство",
    "tableActiveTime": "Последнее время активности",
    "tableOperate": "Действия",
    "cleanup": "Заметка для очистки",
    "IndividualStorageSpaceAdjustment": "Настройка личного пространства хранения",
    "titleTotal": "Всего",
    "PublicDisk": "Облачное хранилище",
    "IndividualDisk": "Личное облако",
    "PerUser": "По пользователю",
    "UsersInTotal": "Всего пользователей",
    "cancel": "Отмена",
    "confirm": "Подтвердить",
    "save": "Сохранить",
    "addSuccess": "Добавлено успешно!",
    "addError": "Ошибка при добавлении!",
    "editSuccess": "Успешно отредактировано!",
    "editError": "Ошибка при редактировании!",
    "delSuccess": "Удалено успешно!",
    "delError": "Ошибка при удалении!",
    "error3000": "Операция не удалась, так как общий размер хранилища был превышен.",
    "error3003": "Не удалось выполнить операцию, проверьте, был ли настроен медиасервер.",
    "IndividualStorage": "Личное хранилище",
    "NoteToCleanup": "Заметка для очистки",
    "updatePersonalSuccess": "Ваше облачное хранилище будет заполнено, пожалуйста, очистите его вовремя",
    "updatePersonalSuccess1": "Изменено и сохранено успешно",
    "storageUsage": "Использование личного хранилища",
    "bindIndividualstorage": "Пользователи могут иметь личное облачное хранилище",
    "UserIndividualstorage": "Пользователи уже настроили личное облачное хранилище",
    "Notificationsuccessfully": "Уведомление отправлено успешно",
    "Notificationfailed": "Не удалось отправить уведомление",
    "tableName": "Имя",
    "userID": "ID пользователя"
  },
  "dashboard": {
    "exportPdf": "Экспортировать PDF",
    "or": "-",
    "warrantyCompletionRate": "Процент ремонта",
    "frequencyOfEachModule": "Процент ремонта каждого функционального модуля",
    "repairHandling": "Статус обработки ремонта",
    "sourceSwitchInput": "Входной переключатель",
    "micVol": "Громкость микрофона",
    "volumeSpeaker": "Громкость динамика",
    "airAonditioner": "Кондиционер",
    "Curtain": "Экран проектора",
    "remoteControlIntelligent": "Пульт дистанционного управления",
    "RS232Control": "Управление Serial",
    "lockElectronic": "Электронные замки",
    "Repairreportcompleted": "Отремонтировано",
    "Totalnumberofrepairsreported": "Общее количество ремонтов",
    "Warrantycompletionrate": "Процент завершения ремонта",
    "startDate": "Дата начала",
    "endDate": "Дата окончания",
    "year": "Год",
    "month": "Месяц",
    "dayTian": "День",
    "placeholderDate": "Выбрать дату",
    "placeholderDateTime": "Выбрать время",
    "devicesNub": "Устройства",
    "userNub": "Пользователи",
    "powerNub": "Мощность (KW/H)",
    "storageUsed": "Используемое пространство (%)",
    "userLoginDevice": "Активное время входа пользователя",
    "devicePowerConsumption": "Ежедневное потребление электроэнергии всеми устройствами",
    "externalDeviceUsageTime": "Использование внешних устройств",
    "equipmentRunningTime": "Использование терминальных устройств",
    "cloudStorageSpace": "Использование памяти",
    "powerConsumptionPort": "Энергопотребление каждого порта питания",
    "mostPopularFile": "Самый популярный файл",
    "commonFunctions": "Обычные функции",
    "commonlyUsed": "Наиболее часто используемый метод вещания",
    "fileName": "Имя файла",
    "usageCount": "Число использований",
    "electricityConsumption": "Потребление электроэнергии",
    "publicStorageUsed": "Используемое общественное хранилище",
    "publicStorageLasted": "Оставшееся общественное хранилище",
    "individualStorageUsed": "Используемое личное хранилище",
    "individualStorageLasted": "Оставшееся личное хранилище",
    "notification": "Уведомление",
    "audioBroadcast": "Аудио трансляция",
    "videoBroadcast": "Видео трансляция",
    "ac": "Кондиционер",
    "hDMISwitch": "Переключатель HDMI",
    "powerControl": "Контроль энергии",
    "powercontrol": "Контроль энергии",
    "Lock": "Блокировка",
    "volumeAdjust": "Регулировка громкости",
    "projectionScreen": "Экран проектора",
    "today": "Сегодня",
    "yesterday": "Вчера",
    "thisWeek": "Эта неделя",
    "lastWeek": "Прошлая неделя",
    "lastMonth": "Прошлый месяц",
    "thisMonth": "Этот месяц",
    "times": "Раз",
    "usage": "Число использований",
    "eachrTitle": "Минуты",
    "total": "Итого",
    "NMPSystemissue": "Проблема системы NMP",
    "displayPower": "Проблема внешнего устройства NMP",
    "externalPower": "Проблема системы MBX",
    "screen": "Проблема внешнего устройства MBX",
    "TotalRepairs": "Общее количество ремонтов",
    "Repaired": "Отремонтировано",
    "Unrepaired": "Не отремонтировано",
    "day": "ДЕНЬ",
    "Minutes": "Минуты",
    "powerConsumption": "Минуты",
    "Date": "Дата",
    "kw": "KW",
    "month1": "ПН",
    "month2": "ВТ",
    "month3": "СР",
    "month4": "ЧТ",
    "month5": "ПТ",
    "month6": "СБ",
    "month7": "ВС",
    "enmonth1": "Янв",
    "enmonth2": "Фев",
    "enmonth3": "Мар",
    "enmonth4": "Апр",
    "enmonth5": "Май",
    "enmonth6": "Июнь",
    "enmonth7": "Июль",
    "enmonth8": "Авг",
    "enmonth9": "Сен",
    "enmonth10": "Окт",
    "enmonth11": "Ноя",
    "enmonth12": "Дек",
    "noData": "Нет данных"
  },
  "input": {
    "fivedigits": "Пожалуйста, введите положительное целое число из 5 цифр",
    "titlUserNameField": "Это имя пользователя должно быть заполнено",
    "thisField": "Это поле должно быть заполнено",
    "ChooseGroup": "Выберите группу",
    "placeholder": "Выбрать",
    "placeholder_type": "Пожалуйста, выберите типы управления устройствами",
    "titlRealNameField": "Пароль должен быть заполнен",
    "thisPasswordField": "Пароль должен быть заполнен",
    "titlPassWordNub": "Менее 15 букв",
    "Post": "Только цифры",
    "passwordNoChinese": "Это поле ввода не может быть заполнено китайскими символами"
  },
  "transfer": {
    "all": "Все",
    "Choose": "Выбрать",
    "Selected": "Выбрано",
    "Subordinate": "Подчиненный"
  },
  "setting": {
    limitPngGif: 'Поддерживаются только форматы PNG / GIF',
    limit3M: 'Размер изображения не должен превышать 3 МБ',
    setting_door_Wallpaper_text: 'Рекомендуемый размер изображения: 1280x800, формат PNG или GIF',

    "reduction": "Восстановить",
    "limitJpg": "Загруженное изображение профиля может быть только в формате PNG!",
    "limit2M": "Размер загруженного изображения профиля не должен превышать 2 МБ!",
    "choseFile": "Выбрать файл",
    "textOne": "1. Рекомендуемое изображение LOGO: размер 117*40, в формате PNG",
    "textTwo": "2. После загрузки перейдите в сенсорную панель, убедитесь, что сенсорная панель подключена к интернету, а затем щелкните по оригинальному логотипу для обновления.",
    "customizeLogo": "Настройки логотипа сенсорной панели",
    "addSuccess": "Настройка выполнена успешно!",
    "settingIp": "Настройки IP-адреса хранения файлов",
    "ServerIP": "IP-адрес сервера:",
    "ServerPort": "Порт сервера:",
    "btnSave": "Сохранить",
    "TimeZoneSetting": "Настройки часового пояса",
    "CurrentTime": "Текущее время:",
    "CurrentTimeZone": "Текущий часовой пояс:",
    "httpsSetting": "Хранение файлов:",
    "utcName": "Среднее время по Гринвичу UTC/GMT",
    "utc0": "Среднее время по Гринвичу, Великобритания, Лиссабон, Торсхавн, Лондон, Дублин, Эдинбург",
    "utc0_5": "",
    "utc1": "Центральная Европа, Западная Африка, Западно-Центральная Африка, Германия, Ирландия, Франция, Амстердам, Италия, Берлин, Рим, Испания, Прага, Белград, Брюссель, Париж, Мадрид, Тунис, Габон, Марокко",
    "utc1_5": "",
    "utc2": "Восточная Европа, Центральная Африка, Турция, Израиль, Южная Африка, Стамбул, Каир, Афины, Дамаск",
    "utc2_5": "",
    "utc3": "Восточная Африка, Россия, Багдад, Кувейт, Москва, Санкт-Петербург",
    "utc3_5": "Иран",
    "utc4": "Абу-Даби, Тбилиси, Дубай, Маврикий, Порт-Луи",
    "utc4_5": "Афганистан",
    "utc5": "Пакистан, Туркменистан, Мальдивы, Узбекистан, Армения, Таджикистан Индия, Мумбаи, Нью-Дели, Бангалор, Калькутта",
    "utc5_5": "Индия, Шри-Ланка",
    "utc6": "Новосибирск, Кыргызстан, Бангладеш, Бутан",
    "utc6_5": "Кокосовые острова Австралия, Вьетнам",
    "utc7": "Таиланд, Бангкок, Ханой, Джакарта",
    "utc7_5": "",
    "utc8": "Китай, Малайзия, Филиппины, Сингапур, Тайвань Китай, Макао Китай, Гонконг Китай",
    "utc8_5": "",
    "utc9": "Япония, Южная Корея, Токио, Сеул, Саппоро, Осака, Восточный Тимор",
    "utc9_5": "Австралийское центральное стандартное время",
    "utc10": "Австралия, Владивосток, Гуам, Канберра, Мельбурн, Сидней, Папуа - Новая Гвинея",
    "utc10_5": "Остров Лорд-Хау, Новый Южный Уэльс, Австралия",
    "utc11": "Соломоновы острова, Сахалин",
    "utc11_5": "Остров Норфолк, Австралия",
    "utc12": "Новая Зеландия, Окленд, Веллингтон, Фиджи, Новая Зеландия, Науру",
    "utc12_5": "",
    "utc13": "Кабо-Верде, Азоры",
    "utc13_5": "",
    "utc14": "Южная Георгия, Фернандо-ди-Норонья",
    "utc14_5": "",
    "utc15": "Бразилия, Сантьяго, Сальвадор, Бразилиа, Уругвай, Аргентина, Суринам",
    "utc15_5": "Стандартное время Ньюфаундленда",
    "utc16": "Венесуэла, Боливия, Парагвай, Чили",
    "utc16_5": "Венесуэла",
    "utc17": "Восточное время (США и Канада), Колумбия, Торонто, Эквадор, Перу, Куба, Нью-Йорк, Гамильтон, Сан-Диего",
    "utc17_5": "",
    "utc18": "Центральное время США и Канады, Мехико, Монтеррей, Чикаго, Хьюстон, Новый Орлеан, Мемфис",
    "utc18_5": "",
    "utc19": "Горное время, Аризона, Мазатлан, Феникс, Солт-Лейк-Сити, Денвер, Эдмонтон",
    "utc19_5": "",
    "utc20": "Тихоокеанское время, Лос-Анджелес, Сан-Франциско, Ванкувер, Сиэтл, Лас-Вегас",
    "utc20_5": "",
    "utc21": "Аляска",
    "utc21_5": "Французская Полинезия, Маркизские острова",
    "utc22": "Гавайи",
    "utc22_5": "",
    "utc23": "Самоа, Ниуэ",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "Название устройства:",
    "Time": "Время:",
    "startDate": "Дата начала",
    "endedDate": "Дата окончания",
    "or": "-",
    "Problem": "Проблема:",
    "btnSearch": "Поиск",
    "tableNO": "Нет",
    "tableDeviceName": "Название устройства",
    "tableGroup": "Группа",
    "tableStatus": "Статус",
    "tableDeliveredTime": "Время доставки",
    "tableSubmitter": "Отправитель",
    "tableUpdatingTime": "Время обновления",
    "tableProblem": "Проблема",
    "tableAdmin": "IT-Admin",
    "tableAdminReply": "Ответ администратора",
    "tableAttachment": "Вложение",
    "state0": "Доставлено",
    "state1": "В процессе",
    "state2": "Завершено",
    "Problem100": "ВСЕ",
    "Problem0": "Системная проблема",
    "Problem1": "Проблема с внешним устройством",
    "ProblemType": "",
    "ProblemType0": "Управление питанием",
    "ProblemType1": "Переключатель HDMI",
    "ProblemType2": "Микрофон",
    "ProblemType3": "Динамик",
    "ProblemType4": "Кондиционер",
    "ProblemType5": "Экран проектора",
    "ProblemType6": "Электронный замок",
    "ProblemType7": "Трансляция A/V",
    "ProblemType8": "Управление IR",
    "ProblemType9": "Управление Serial",
    "dialogDeviceName": "Название устройства",
    "dialogDeviceID": "ID устройства",
    "dialogGroup": "Группа",
    "dialogSubmitter": "Отправитель",
    "dialogStatus": "Выберите статус",
    "dialogProblem": "Проблема",
    "dialogNotes": "Заметки",
    "dialogRepairation": "Ремонт",
    "dialogInProcess": "В процессе",
    "dialogCompleted": "Завершено",
    "editSuccess": "Редактирование успешно!",
    "editError": "Не удалось отредактировать!",
    "problemRequired": "Пожалуйста, выберите тип проблемы",
    "detailRequired": "Пожалуйста, подробно опишите проблему",
    "statusRequired": "Пожалуйста, выберите статус журнала",
    "btnCancel": "Отменить",
    "DeliveredTime": "Время доставки",
    "UpdatingTime": "Время обновления",
    "ITAdmin": "IT-Admin",
    "AdminReply": "Ответ администратора",
    "Note": "Заметка",
    "Detail": "Детали",
    "controlPanel": "Панель управления",
    "DeviceType": "Тип",
    "dialogDeliveredTime": "Время доставки",
    "Submitter": "Отправитель"
  },
  "remoteControl": {
    "QuickActionName": "Имя",
    "DeviceType": "Тип",
    "Description": "Описание",
    "tableDescription": "Описание",
    "editRemoteControl": "Редактировать код пульта дистанционного управления",
    "QuickActionNameInput": "Имя",
    "DescriptionInput": "Описание",
    "save": "Сохранить",
    "Brand": "Бренд",
    "Model": "Модель",
    "EditACControlCode": "Редактировать код управления кондиционером",
    "acBrand": "Бренд кондиционера",
    "acModel": "Модель кондиционера"
  },
  "card": {
    "btnAddCard": "Добавить карту",
    "btnBatchAddCard": "Пакетное добавление карт",
    "tableCard": "Номер карты",
    "tableState": "Статус",
    "tableUser": "Привязать пользователя",
    "tableID": "Имя пользователя",
    "tableType": "Тип карты",
    "tableFfective": "Срок действия",
    "dialogCard": "Номер карты:",
    "dialogState": "Статус:",
    "dialogUser": "Привязать пользователя:",
    "dialogID": "Имя пользователя:",
    "dialogType": "Тип карты:",
    "dialogFfective": "Срок действия:",
    "dialogRemarks": "Примечания:",
    "dialogAddTitle": "Добавить карту",
    "dialogEidtTitle": "Редактировать карту",
    "code2201": "Неверный формат срока действия карты",
    "code2202": "Эта карта уже привязана",
    "code2203": "Этот пользователь уже привязан",
    "code2204": "Эта карта не привязана",
    "mastCard": "Основная карта",
    "regularCard": "Общая карта",
    "permanent": "Постоянная",
    "coxPermanent": "Постоянная",
    "coxTime": "На определенный период времени",
    "tableDeviceName": "Название устройства",
    "tableDeviceID": "ID устройства",
    "tableOperating": "Операция",
    "tableOperatingTime": "Время работы",
    "tableCardID": "Номер карты",
    "tableCardType": "Тип карты",
    "tabluserName": "Имя пользователя",
    "tabluserId": "ID пользователя",
    "unlockPanel": "Открыть панель",
    "unlock": "Открыть дверь",
    "conAll": "Все",
    "btnEnable": "Включить",
    "btnDisable": "Выключить",
    "enableSuccess": "Успешно включено",
    "stopSuccess": "Успешно выключено",
    "enableError": "Не удалось включить",
    "stopError": "Не удалось выключить",
    "batchCard": "Пакетный номер карты:",
    "titlCardField": "Номер карты не может быть пустым",
    "titlCardFieldFormat": "Только буквы и цифры",
    "dialogBachAddTitle": "Пакетное добавление карт",
    "pleaseTryAgain1": "Неверный номер карты (№:",
    "pleaseTryAgain2": "  ), попробуйте еще раз"
  },
  privacy: {
    PrivacyPolicy: 'Microsoft Organization Binding Privacy Agreement',
    Byusing: 'Dear User,',
    whatinformation: 'Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking “Agree,” you confirm that you have read and accepted all terms of this agreement.',
    EffectiveDate: 'Effective Date: August 4, 2025',
    title1: 'Required Permissions & Collected Data',
    title1Respects1: 'To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:',
    title1Respects2: 'Delegated Permissions',
    Respects2formation: 'These permissions allow Q-NEX to access your Microsoft account data after login and consent:',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: 'Permission Name: Full access to user calendars',
    Respects2formation4: 'Description: Allows the app to create, read, update, and delete events in user calendars.',
    Respects2formation5: 'Purpose: Synchronize personal calendar meetings with the Q-NEX system.',
    Respects2formation6: 'offline_access',
    Respects2formation7: 'Permission Name: Maintain access to data you’ve granted',
    Respects2formation8: 'Description: Allows the app to access authorized data even when you’re not actively using it.',
    Respects2formation9: 'Purpose: Ensures meeting information remains synced even when users are offline.',
    Respects2formation10: 'Openid',
    Respects2formation11: 'Permission Name: Sign in as you',
    Respects2formation12: 'Description: Enables login via work/school accounts and allows the app to read basic profile details.',
    Respects2formation13: 'Purpose: Authenticates user identity for security and associates profiles with meeting data.',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: 'Permission Name: Read all company places',
    Respects2formation16: 'Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.',
    Respects2formation17: 'Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.',

    tp1: 'Application Permissions (Requires Admin Consent)',
    tp2: 'These permissions enable Q-NEX to sync data automatically without manual reauthorization:',
    tp3: 'Calendars.ReadWrite',
    tp4: 'Permission Name: Read and write calendars in all mailboxes',
    tp5: 'Description: Allows the app to create, read, update, and delete calendar events without user sign-in.',
    tp6: 'Purpose: Syncs schedules from all company meeting room resource mailboxes.',
    tp7: 'Directory.Read.All',
    tp8: 'Permission Name: Read directory data',
    tp9: 'Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.',
    tp10: 'Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.',
    tp11: 'User.Read.All',
    tp12: 'Permission Name: Read all users’ full profiles',
    tp13: 'Description: Allows the app to read user profiles without user sign-in.',
    tp14: 'Purpose: Identifies meeting participants.',
    tp15: 'Place.Read.All',
    tp16: 'Permission Name: Read all company places',
    tp17: 'Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.',
    tp18: 'Purpose: Retrieves full meeting room resource lists and syncs availability statuses.',

    title2: 'Purpose of Data Usage',
    title2Respects1: 'Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.',
    title2Respects2: 'Automatically update room availability to prevent scheduling conflicts.',
    title2Respects3: 'Provide a unified meeting management experience.',

    title3: 'Data Storage & Protection',
    title3Respects1: 'All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.',
    title3Respects2: 'Q-NEX does not share calendar data with third parties unless legally required or for system security.',
    title3Respects3: 'For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.',

    title4: 'Your Rights',
    title4Respects1: 'You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.',

    title5: 'Important Notes',
    title5Respects1: 'Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.',
    title5Respects2: 'Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.',

    contactInformation: 'Contact Information',
    contactInformationContent: 'If you have any questions, please contact: info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/ru.js